module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('form-wizard', {
    attrs: {
      "shape": "square",
      "color": "#20a0ff",
      "error-color": "#ff4949",
      "title": "Cadastro de Pacote de Viagem",
      "subtitle": "Avance pelas guias para finalizar o cadastro"
    },
    on: {
      "on-complete": _vm.onComplete
    }
  }, [_c('tab-content', {
    attrs: {
      "title": "Informações do Pacote",
      "icon": "fa fa-suitcase",
      "before-change": _vm.validateFirstStep
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-form-inline",
    attrs: {
      "model": _vm.informacoesPacote,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Título"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.informacoesPacote.titulo),
      expression: "informacoesPacote.titulo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "sizing-addon1"
    },
    domProps: {
      "value": (_vm.informacoesPacote.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.informacoesPacote, "titulo", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Descrição"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.informacoesPacote.descricao),
      expression: "informacoesPacote.descricao"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "1",
      "cols": "12"
    },
    domProps: {
      "value": (_vm.informacoesPacote.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.informacoesPacote, "descricao", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Quantidade de Passageiros"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.informacoesPacote.quantidadePassageiros),
      expression: "informacoesPacote.quantidadePassageiros"
    }],
    staticClass: "form-control ",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.informacoesPacote.quantidadePassageiros)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.informacoesPacote, "quantidadePassageiros", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Preço"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.informacoesPacote.preco),
      expression: "informacoesPacote.preco"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control currency",
    attrs: {
      "value": "0",
      "min": "0",
      "step": "0.01",
      "data-number-to-fixed": "2",
      "data-number-stepfactor": "100"
    },
    domProps: {
      "value": (_vm.informacoesPacote.preco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.informacoesPacote, "preco", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Imagens"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file-input-pacote",
      "multiple": ""
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Tags do Pacote",
      "prop": "fullName"
    }
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.tagsParaPacote,
      "selected-options": _vm.informacoesPacote.tags,
      "placeholder": "Tags do Pacote"
    },
    on: {
      "select": _vm.onSelectPacote
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', [_vm._v("Ativo")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.informacoesPacote.ativo),
      callback: function($$v) {
        _vm.$set(_vm.informacoesPacote, "ativo", $$v)
      },
      expression: "informacoesPacote.ativo"
    }
  })], 1)])])], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Informações do Hotel",
      "icon": "fa fa-bed",
      "before-change": _vm.validateSecondStep
    }
  }, [_c('el-form', {
    ref: "ruleFormLogin",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.informacoesHotel,
      "rules": _vm.rulesLogin
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Nome"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.informacoesHotel.nome),
      expression: "informacoesHotel.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "sizing-addon1"
    },
    domProps: {
      "value": (_vm.informacoesHotel.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.informacoesHotel, "nome", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Endereço"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.informacoesHotel.endereco),
      expression: "informacoesHotel.endereco"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "1",
      "cols": "12"
    },
    domProps: {
      "value": (_vm.informacoesHotel.endereco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.informacoesHotel, "endereco", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Tags do Hotel",
      "prop": "fullName"
    }
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.tagsParaHotel,
      "selected-options": _vm.informacoesHotel.tags,
      "placeholder": "Tags do Hotel"
    },
    on: {
      "select": _vm.onSelectHotel
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Imagens"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file-input-hotel",
      "multiple": ""
    }
  })])], 1)])])], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Informações Voo",
      "icon": "fa fa-plane"
    }
  }, [_c('el-form', {
    ref: "ruleFormLogin",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.informacoesVoo,
      "rules": _vm.rulesLogin
    }
  }, [_vm._l((_vm.informacoesVoo), function(voo, index) {
    return _c('div', {
      staticClass: "voosDiv"
    }, [_c('box', [_c('div', {
      attrs: {
        "slot": "body"
      },
      slot: "body"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-3"
    }, [_c('el-form-item', {
      staticClass: "form-item",
      attrs: {
        "label": "Companhia"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (voo.companhia),
        expression: "voo.companhia"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "aria-describedby": "sizing-addon1"
      },
      domProps: {
        "value": (voo.companhia)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(voo, "companhia", $event.target.value)
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('el-form-item', {
      staticClass: "form-item",
      attrs: {
        "label": "Tipo"
      }
    }, [_c('label', {
      staticClass: "radio-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (voo.tipo),
        expression: "voo.tipo"
      }],
      attrs: {
        "type": "radio",
        "value": "ida",
        "checked": ""
      },
      domProps: {
        "checked": _vm._q(voo.tipo, "ida")
      },
      on: {
        "change": function($event) {
          return _vm.$set(voo, "tipo", "ida")
        }
      }
    }), _vm._v("Ida")]), _vm._v(" "), _c('label', {
      staticClass: "radio-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (voo.tipo),
        expression: "voo.tipo"
      }],
      attrs: {
        "type": "radio",
        "value": "volta"
      },
      domProps: {
        "checked": _vm._q(voo.tipo, "volta")
      },
      on: {
        "change": function($event) {
          return _vm.$set(voo, "tipo", "volta")
        }
      }
    }), _vm._v("Volta")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3 adicionaVoo"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removerVoo(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-3"
    }, [_c('el-form-item', {
      staticClass: "form-item",
      attrs: {
        "label": "Local Saída"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (voo.localSaida),
        expression: "voo.localSaida"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "aria-describedby": "sizing-addon1"
      },
      domProps: {
        "value": (voo.localSaida)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(voo, "localSaida", $event.target.value)
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('el-form-item', {
      staticClass: "form-item",
      attrs: {
        "label": "Local Chegada"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (voo.localChegada),
        expression: "voo.localChegada"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "aria-describedby": "sizing-addon1"
      },
      domProps: {
        "value": (voo.localChegada)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(voo, "localChegada", $event.target.value)
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('el-form-item', {
      staticClass: "form-item",
      attrs: {
        "label": "Hora de Saída"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (voo.horaSaida),
        expression: "voo.horaSaida"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "datetime-local",
        "aria-describedby": "sizing-addon1"
      },
      domProps: {
        "value": (voo.horaSaida)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(voo, "horaSaida", $event.target.value)
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('el-form-item', {
      staticClass: "form-item",
      attrs: {
        "label": "Hora de Chegada"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (voo.horaChegada),
        expression: "voo.horaChegada"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "datetime-local",
        "aria-describedby": "sizing-addon1"
      },
      domProps: {
        "value": (voo.horaChegada)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(voo, "horaChegada", $event.target.value)
        }
      }
    })])], 1)])])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 adicionaVoo",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    on: {
      "click": _vm.adicionarVoo
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Adicionar Voo")])])])])], 2)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "prev",
      "type": "primary"
    },
    slot: "prev"
  }, [_vm._v("Anterior")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "next",
      "type": "primary"
    },
    slot: "next"
  }, [_vm._v("Próximo")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.gravando),
      expression: "!gravando"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "finish",
      "type": "primary"
    },
    slot: "finish"
  }, [_vm._v("Confirmar")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "finish",
      "type": "primary",
      "disabled": ""
    },
    slot: "finish"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Confirmar")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dfcb25d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/PacotesViagens/novoPacote.vue
// module id = 1211
// module chunks = 1